import { isMobileLayout } from "./mobile.js";

let rafId = 0;

function getActiveTableScroll() {
  const scrolls = document.querySelectorAll(".panel.active .table-scroll");
  for (const scroll of scrolls) {
    const style = window.getComputedStyle(scroll);
    const rect = scroll.getBoundingClientRect();
    if (style.display !== "none" && rect.height > 0 && rect.width > 0) {
      return scroll;
    }
  }
  return null;
}

export function syncDesktopTableViewport() {
  if (isMobileLayout()) return;

  const scroll = getActiveTableScroll();
  if (!scroll) return;

  const rect = scroll.getBoundingClientRect();
  const available = Math.max(120, Math.floor(window.innerHeight - rect.top - 12));

  document.documentElement.style.setProperty(
    "--desktop-table-height",
    `${available}px`
  );
}

export function setupDesktopViewportSync() {
  const schedule = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      syncDesktopTableViewport();
    });
  };

  schedule();
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("orientationchange", schedule, { passive: true });
  window.addEventListener("app-layoutchange", schedule);

  return schedule;
}
